import axios from 'axios';

const list = (data) => axios.get('/pro/notify/list', data);
const save = (data) => axios.post('/pro/notify/save', data);
const del = (data) => axios.post('/pro/notify/delete', data);


export default {
  list,
  save,
  del,

}


